import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    axiosBusy: 0,
    countryCodes: [
      { code: "de", prefix: "49"},
      { code: "ch", prefix: "41"},
      { code: "at", prefix: "43"},
      { code: "fl", prefix: "423"},
    ],
  },
  getters: {
    axiosIsBusy: state => (state.axiosBusy === 0 ? false : true),
    getCountryCodes: state => {
      return state.countryCodes.map(cc => {
        let re = new RegExp('^[+0]{1,2}' + cc.prefix);
        return { code: cc.code, prefix: '+' + cc.prefix, regexp: re};
      });
    },
  },
  mutations: {
    setAxiosBusy(state) {
      state.axiosBusy++;
      let buttons = document.querySelectorAll('.axios');
      Array.prototype.forEach.call(buttons, function(el){
        el.classList.toggle('is-busy')
      });
    },
    setAxiosIdle(state) {
      state.axiosBusy--;
      let buttons = document.querySelectorAll('.axios');
      Array.prototype.forEach.call(buttons, function(el){
        el.classList.toggle('is-busy')
      });
    }
  },
  actions: {
    axiosBusy(context) {
      context.commit("setAxiosBusy");
    },
    axiosIdle(context) {
      context.commit("setAxiosIdle");
    }
  }
})
